<template>
  <FormElement :name="name" :label="label" :value="formatValue(value)">
    <slot slot="tooltip" name="tooltip"></slot>
    <input
      slot="input"
      @input="onChange"
      :name="name"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :value="value"
    />
  </FormElement>
</template>

<script>
import Tooltip from "./Tooltip.vue"
import FormElement from "./FormElement.vue"

export default {
  name: "FormRange",
  components: {
    FormElement
  },
  props: {
    label: {
      required: false,
      type: String
    },
    formatValue: {
      required: false,
      type: Function,
      default: v => v
    },
    name: {
      required: true,
      type: String
    },
    min: {
      required: true,
      type: String
    },
    max: {
      required: true,
      type: String
    },
    step: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Number | String
    }
  },
  methods: {
    onChange: function(e) {
      this.$emit("update:value", e.target.value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

$thumb-responsive-height: 30px;
$thumb-responsive-width: 30px;

$thumb-height: 16px;
$thumb-width: 16px;
$thumb-background: $color-white-dark;
$thumb-box-shadow: 1.9px 1.9px 3.4px rgba(0, 0, 0, 0.85),
  0px 0px 1.9px rgba(13, 13, 13, 0.85);

$track-background: $color-dark-darker;
$track-border-radius: 3px;
$track-height: 5px;

@mixin track {
  height: $track-height;
  background: $track-background;
  border: none;
  border-radius: $track-border-radius;
}

@mixin thumb-responsive {
  @include thumb;
  height: $thumb-responsive-height;
  width: $thumb-responsive-width;
  margin-top: -14px;
}

@mixin track-focused {
  background: $color-dark-darkest;
}

@mixin thumb {
  -webkit-appearance: none;
  border: none;
  height: $thumb-height;
  width: $thumb-width;
  border-radius: 50%;
  background: $thumb-background;
  box-shadow: $thumb-box-shadow;
  position: relative;
  margin-top: -5px;
}

/* Disable scrolling while touching range inputs */
input[type="range"] {
  touch-action: none;
}

input[type="range"] {
  -webkit-appearance: none;
  background: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  @include track;
}

input[type="range"]::-ms-track {
  @include track;
}

input[type="range"]::-moz-range-track {
  @include track;
}

input[type="range"]::-webkit-slider-thumb {
  @include thumb;
}

input[type="range"]::-ms-thumb {
  @include thumb;
}

input[type="range"]::-moz-range-thumb {
  @include thumb;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  @include track-focused;
}

input[type="range"]:focus::-ms-track {
  @include track-focused;
}

input[type="range"]:focus::-moz-range-track {
  @include track-focused;
}

@media (max-width: 767px) {
  input[type="range"]::-webkit-slider-thumb {
    @include thumb-responsive;
  }

  input[type="range"]::-ms-thumb {
    @include thumb-responsive;
  }

  input[type="range"]::-moz-range-thumb {
    @include thumb-responsive;
  }
}
</style>
